<app-header [title]="title" [subtitle]="subtitle"></app-header>




<article class="choose-palette">
  <main class="  container-fuid">
    <div class="row">
<!--      <div class="col-lg-6 item top-design">-->

<!--        <h2  >Top Design</h2>-->
<!--        <div class="maincolors">-->
<!--          <div class="colors">-->
<!--            <div *ngFor="let color of mobilePaletteColors[4]"><span class="box"-->
<!--                                                                    [ngStyle]="{'background-color': color.rgb}"></span><span class="code">{{color.code}}</span></div>-->
<!--          </div>-->
<!--        </div>-->


<!--          <a  routerLink="/compose-color-set/{{houseType}}/{{KnaufPalettes.TopDesign}}">-->
<!--          <div class="view overlay zoom">-->

<!--            <img src="{{palettes[KnaufPalettes.TopDesign].imgs[houseType]}}" class="img-fluid " alt="zoom">-->

<!--            <div class="mask flex-center rgba-white-strong">-->
<!--              <div   style="">-->
<!--                Paleta najbardziej różnorodnych kolorów, przywołujących ciepłe i intensywne barwy architektury-->
<!--                śródziemnomorskiej. Punkt wyjścia do tworzenia odważnych i bogatych zestawień kolorystycznych na-->
<!--                elewacjach budynków, zainspirowanych nowoczesną architekturą światową.<br/>-->

<!--                <div class="leaning palette ">-->
<!--                  <div class="content">-->
<!--                    <div class="palette-basic">-->
<!--                      <h4 >Kolory podstawowe</h4>-->
<!--                      <div class="colors">-->
<!--                                <span *ngFor="let color of palettes[KnaufPalettes.SwiatoweInspiracje].basic"-->
<!--                                      [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="palette-ext">-->
<!--                      <h4  >Kolory uzupełniające</h4>-->
<!--                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.SwiatoweInspiracje].extended"-->
<!--                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>-->
<!--                    </div>-->
<!--                    <div class="palette-accent">-->
<!--                      <h4  >Akcenty</h4>-->
<!--                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.SwiatoweInspiracje].accent"-->
<!--                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <button class="btn btn-success clearfix">Dalej</button>-->
<!--              </div>-->


<!--            </div>-->
<!--          </div>-->
<!--        </a>-->

<!--      </div>-->
      <div class="col-lg-6 item miejski-szyk">

        <h2  >Miejski szyk</h2>
        <div class="maincolors">
          <div class="colors">
            <div *ngFor="let color of mobilePaletteColors[0]">
              <span class="box" [ngStyle]="{'background-color': color.rgb}"></span><span class="code">{{color.code}}</span></div>
          </div>
        </div>


        <a  routerLink="/compose-color-set/{{houseType}}/{{KnaufPalettes.MiejskiSzyk}}">
          <div class="view overlay zoom">

            <img src="{{palettes[KnaufPalettes.MiejskiSzyk].imgs[houseType]}}" class="img-fluid " alt="zoom">

            <div class="mask flex-center rgba-white-strong">
              <div   style="">
                Paleta kolorów oparta na odcieniach szarości, inspirowana stylem skandynawskim, minimalizmem i
                najnowszymi trendami w projektowaniu. Doskonale sprawdza się w połączeniu z prostymi bryłami i
                modernistyczną architekturą, spotykaną w przypadku nowo budowanych domów, częściej w przestrzeni
                miejskiej.<br/>

                <div class="leaning palette ">
                  <div class="content">
                    <div class="palette-basic">
                      <h4 >Kolory podstawowe</h4>
                      <div class="colors">
                                <span *ngFor="let color of palettes[KnaufPalettes.MiejskiSzyk].basic"
                                      [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>
                      </div>
                    </div>
                    <div class="palette-ext">
                      <h4  >Kolory uzupełniające</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.MiejskiSzyk].extended"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                    <div class="palette-accent">
                      <h4  >Akcenty</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.MiejskiSzyk].accent"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-success clearfix">Dalej</button>
              </div>


            </div>
          </div>
        </a>

      </div>


      <div class="col-lg-6 item swiatowe-inspiracje">

        <h2  >Światowe inspiracje</h2>
        <div class="maincolors">
          <div class="colors">
            <div *ngFor="let color of mobilePaletteColors[2]"><span class="box"
                                                                    [ngStyle]="{'background-color': color.rgb}"></span><span class="code">{{color.code}}</span></div>
          </div>
        </div>


        <a  routerLink="/compose-color-set/{{houseType}}/{{KnaufPalettes.SwiatoweInspiracje}}">
          <div class="view overlay zoom">

            <img src="{{palettes[KnaufPalettes.SwiatoweInspiracje].imgs[houseType]}}" class="img-fluid " alt="zoom">

            <div class="mask flex-center rgba-white-strong">
              <div   style="">
                Paleta najbardziej różnorodnych kolorów, przywołujących ciepłe i intensywne barwy architektury
                śródziemnomorskiej. Punkt wyjścia do tworzenia odważnych i bogatych zestawień kolorystycznych na
                elewacjach budynków, zainspirowanych nowoczesną architekturą światową.<br/>

                <div class="leaning palette ">
                  <div class="content">
                    <div class="palette-basic">
                      <h4 >Kolory podstawowe</h4>
                      <div class="colors">
                                <span *ngFor="let color of palettes[KnaufPalettes.SwiatoweInspiracje].basic"
                                      [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>
                      </div>
                    </div>
                    <div class="palette-ext">
                      <h4  >Kolory uzupełniające</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.SwiatoweInspiracje].extended"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                    <div class="palette-accent">
                      <h4  >Akcenty</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.SwiatoweInspiracje].accent"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-success clearfix">Dalej</button>
              </div>


            </div>
          </div>
        </a>

      </div>

    </div>

    <!--    row 2-->

    <div class="row">
      <!--      klasyczna elegancja-->

      <!--      W ZGODZIE Z NATURĄ-->


      <div class="col-lg-6 item klasyczna-elegancja">

        <h2  >KLASYCZNA ELEGANCJA</h2>
        <div class="maincolors">
          <div class="colors">
            <div *ngFor="let color of mobilePaletteColors[1]"><span class="box"
                                                                    [ngStyle]="{'background-color': color.rgb}"></span><span class="code">{{color.code}}</span></div>
          </div>
        </div>


        <a  routerLink="/compose-color-set/{{houseType}}/{{KnaufPalettes.KlasycznaElegancja}}">
          <div class="view overlay zoom">

            <img src="{{palettes[KnaufPalettes.KlasycznaElegancja].imgs[houseType]}}" class="img-fluid " alt="zoom">

            <div class="mask flex-center rgba-white-strong">
              <div   style="">
                Paleta ciepłych, stonowanych barw dla osób szukających inspiracji w tradycyjnych projektach
                architektonicznych. Szlachetne beże i brązy nadadzą nawet nowoczesnym domom klasyczny, elegancki
                wygląd.<br/>

                <div class="leaning palette ">
                  <div class="content">
                    <div class="palette-basic">
                      <h4  >Kolory podstawowe</h4>
                      <div class="colors">
                                <span *ngFor="let color of palettes[KnaufPalettes.KlasycznaElegancja].basic"
                                      [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>
                      </div>
                    </div>
                    <div class="palette-ext">
                      <h4  >Kolory uzupełniające</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.KlasycznaElegancja].extended"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                    <div class="palette-accent">
                      <h4  >Akcenty</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.KlasycznaElegancja].accent"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-success clearfix">Dalej</button>
              </div>


            </div>
          </div>
        </a>

      </div>
      <div class="col-lg-6 item wzgodzie-znatura">

        <h2  >W ZGODZIE Z NATURĄ</h2>
        <div class="maincolors">
          <div class="colors">
            <div *ngFor="let color of mobilePaletteColors[3]"><span class="box"
                                                                    [ngStyle]="{'background-color': color.rgb}"></span><span class="code">{{color.code}}</span></div>
          </div>
        </div>


        <a  routerLink="/compose-color-set/{{houseType}}/{{KnaufPalettes.WZgodzieZNatura}}">
          <div class="view overlay zoom">

            <img src="{{palettes[KnaufPalettes.WZgodzieZNatura].imgs[houseType]}}" class="img-fluid " alt="zoom">

            <div class="mask flex-center rgba-white-strong">
              <div   style="">
                Paleta najbardziej różnorodnych kolorów, przywołujących ciepłe i intensywne barwy architektury
                śródziemnomorskiej. Punkt wyjścia do tworzenia odważnych i bogatych zestawień kolorystycznych na
                elewacjach budynków, zainspirowanych nowoczesną architekturą światową.<br/>

                <div class="leaning palette ">
                  <div class="content">
                    <div class="palette-basic">
                      <h4  >Kolory podstawowe</h4>
                      <div class="colors">
                                <span *ngFor="let color of palettes[KnaufPalettes.WZgodzieZNatura].basic"
                                      [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>
                      </div>
                    </div>
                    <div class="palette-ext">
                      <h4  >Kolory uzupełniające</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.WZgodzieZNatura].extended"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                    <div class="palette-accent">
                      <h4  >Akcenty</h4>
                      <div class="colors"><span *ngFor="let color of palettes[KnaufPalettes.WZgodzieZNatura].accent"
                                                [ngStyle]="{'background': color.rgb}" [title]="color.code"></span></div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-success clearfix">Dalej</button>
              </div>


            </div>
          </div>
        </a>

      </div>
    </div>
    <div class="row">
      <!--      klasyczna elegancja-->

      <!--      W ZGODZIE Z NATURĄ-->

    </div>

  </main>

</article>

<article class="choose-palette-mobile">
  <main>
    <div *ngFor="let palette of mobilePalettes, let i = index, let last=last"
         [ngStyle]="{'background-color': palette.background}" (click)="onMobilePaletteSelect(i)" class="palette">
      <h3>{{palette.name}}</h3>
      <div class="palette-content" [ngClass]="{'active': mobilePaletteSelected==i}">
        <div class="proposed">
          <div *ngFor="let color of mobilePaletteColors[i]"><span class="box"
                                                                  [ngStyle]="{'background-color': color.rgb}"></span><strong>{{color.code}}</strong></div>
        </div>
        <div class="palette-colors">
          <h4  >Kolory podstawowe</h4>
          <div class="colors">
            <span *ngFor="let color of palette.basic" [ngStyle]="{'background-color': color.rgb}"></span>
          </div>
          <h4  >Kolory uzupełniające</h4>
          <div class="colors">
            <span *ngFor="let color of palette.extended" [ngStyle]="{'background-color': color.rgb}"></span>
          </div>

          <h4  >Akcenty</h4>
          <div class="colors">
            <span *ngFor="let color of palette.accent" [ngStyle]="{'background-color': color.rgb}"></span>
          </div>
        </div>
      </div>
    </div>
  </main>
  <app-footer [next]="next"></app-footer>
</article>
